import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Card, Statistic, Row,Col } from 'antd';


class PaymentDetailsSummary extends Component {

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    render() {
        const rowLabelDaily = `DAILY Invoices`;
        const rowLabelMonthly = `MONTHLY Invoices`;
        return (
            <Card>
                <Row gutter={16}>
                    <Col span={8}>
                        <Statistic title={rowLabelDaily.toUpperCase()} value={this.store.dailyInvoicesCount} />
                    </Col>
                    <Col span={8}>
                        <Statistic title={rowLabelMonthly.toUpperCase()} value={this.store.monthlyInvoicesCount} />
                    </Col>
                    <Col span={8} style={{textAlign:"right"}}>
                        <Statistic title="Total IC" value={this.store.totalIcPayable} />
                    </Col>
                </Row>
            </Card>
        )
    }
}

export default observer(PaymentDetailsSummary)
